import { createClass as _createClass, objectSpread2 as _objectSpread2, classCallCheck as _classCallCheck } from '../_virtual/_rollupPluginBabelHelpers.js';
import axios from 'axios';
import { httpConstants, responseErrorMessages } from './constants.js';

var needsPayload = {
  POST: true,
  GET: false
};
var SUCCESS_STATUS_CODES = {
  200: true
};
var http = /*#__PURE__*/function () {
  function http() {
    _classCallCheck(this, http);
  }
  return _createClass(http, null, [{
    key: "httpRequest",
    value: function httpRequest(url) {
      var reqParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : httpConstants.HTTP_METHODS.GET;
      var reqHeaders = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : httpConstants.HTTP_REQ_DEFAULT_HEADERS;
      var responseType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'json';
      return new Promise(function (resolve, reject) {
        var paramsStr = JSON.stringify(reqParams);
        var payload = {};
        if (needsPayload[method]) {
          payload = {
            data: paramsStr
          };
        }
        var headers = _objectSpread2({}, reqHeaders);
        axios(_objectSpread2({
          url: url,
          method: method,
          headers: headers,
          responseType: responseType
        }, payload)).then(function (res) {
          var status = res.status,
            responseData = res.data;
          if (SUCCESS_STATUS_CODES[status]) {
            resolve(responseData || {
              message: 'Success'
            });
          } else {
            reject(httpConstants.HTTP_REQ_ERROR_MAP[status] || {
              status: status,
              errorMessage: responseData.error.message || responseErrorMessages.DEFAULT_ERROR_MESSAGE
            });
          }
        }, function (error) {
          var errorData = error.response && error.response.data || error.toJSON && error.toJSON() || {};
          var errorMeta = error.toJSON && error.toJSON() || {};
          reject(_objectSpread2(_objectSpread2({}, errorData), {}, {
            status: errorData.status || errorMeta.status || 404,
            errorMessage: error.message
          }));
        });
      });
    }
  }]);
}();

export { http };
